import {
    getGileClassesFetchReducer,
} from '../../slices/gq-admin/gile-class';

export const gqAdminGileClassesReducers = {
    getGileClassesFetch: getGileClassesFetchReducer,
};
